export default __webpack_public_path__ + "static/media/users-open.88351eb2.png";